import React from 'react';
import { Box, Typography, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, IconButton } from '@mui/material';
import EditIcon from '@/letsgo/icons/Edit';
import DeleteIcon from '@/letsgo/icons/Delete'; // Import DeleteIcon

interface TeamMember {
  id: string;
  name: string;
  email: string;
  role: string;
  status: string;
  joinedAt: string;
}

interface TeamMembersTableProps {
  members: TeamMember[];
  onEditRole: (member: { id: string; name: string; currentRole: string }) => void;
  onRemoveMember: (member: { id: string; name: string }) => void; // New prop for removing member
}

const TeamMembersTable: React.FC<TeamMembersTableProps> = ({ members, onEditRole, onRemoveMember }) => {
  return (
    <Box sx={{ mt: 4 }}>
      <Typography variant="h5" component="h2" gutterBottom>
        Team Members
      </Typography>
      <Box sx={{ overflowX: 'auto' }}> {/* Add responsive horizontal scroll */}
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="team members table">
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Role</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Joined At</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {members.map((member) => (
                <TableRow key={member.id}>
                  <TableCell>{member.name}</TableCell>
                  <TableCell>{member.email}</TableCell>
                  <TableCell>{member.role}</TableCell>
                  <TableCell>{member.status}</TableCell>
                  <TableCell>{member.joinedAt}</TableCell>
                  <TableCell>
                    <IconButton aria-label="edit role" onClick={() => onEditRole({ id: member.id, name: member.name, currentRole: member.role })}>
                      <EditIcon />
                    </IconButton>
                    <IconButton aria-label="remove member" onClick={() => onRemoveMember({ id: member.id, name: member.name })} color="error">
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
      {members.length === 0 && (
        <Typography variant="body1" sx={{ mt: 2, textAlign: 'center' }}>
          No team members yet. Invite your first team member!
        </Typography>
      )}
    </Box>
  );
};

export default TeamMembersTable;
